<div class="separacion">
  <img src="assets/talleres.png" alt="image" height="200" class="imagen-movil">
</div>
<div id="talleres" class="card-container col-12 row full-height">
    <div class="col-12 col-lg-12 centrar">
      <p>La prevención es uno de los aspectos más importante a la hora de abordar los posibles problemas que puedan producirse en el ámbito escolar o familiar.</p><br>
      <p>Por este motivo, en colaboración con la Psicóloga <a class="naranja redes" href="https://rospsicologia.com/">Isabel Ros</a>, realizo talleres psicoeducativos en centros escolares.</p><br>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="col-12 col-lg-12 separacion">
            <img src="assets/acosoEscolar.png" alt="image" height="200">
          </div>
          <h2 class="titulo naranja separacion">ACOSO ESCOLAR</h2>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">A QUIÉN VA DIRIGIDO</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Familias</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Docentes</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Estudiantes</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">CONTENIDOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Buenos tratos</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Empatía</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Ciberacoso</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">OBJETIVOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Fomentar el bienestar en el aula</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Promover relaciones sanas entre iguales</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Interiorizar el sentido de respeto mutuo</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Identificar y distinguir lo que es y lo que no es acoso</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Proporcionar herramientas para gestionar situaciones de acoso</p>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
        <div class="col-12 col-lg-6">
          <div class="col-12 col-lg-12 separacion">
            <img src="assets/estudiarAprendiendo.png" alt="image" height="200">
          </div>
          <h2 class="titulo naranja separacion">ESTUDIAR APRENDIENDO</h2>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">A QUIÉN VA DIRIGIDO</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Estudiantes</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">CONTENIDOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Estudiar / Aprender</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Aprendizaje visual</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Pensamiento creativo</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">OBJETIVOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Mejorar la capacidad de atención y la motivación</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Fomentar el aprendizaje significativo</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Desarrollar habilidades de pensamiento creativo</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Interiorizar nuevas formas de estudiar y de aprender</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Disfrutar del proceso de aprendizaje</p>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="col-12 col-lg-12 separacion">
            <img src="assets/usoTecnologias.png" alt="image" height="200">
          </div>
          <h2 class="titulo naranja separacion">USO DE TECNOLOGÍAS</h2>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">A QUIÉN VA DIRIGIDO</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Familias</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Estudiantes</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">CONTENIDOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Tiempo conectados</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Beneficios y riesgos</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Ciberacoso</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">OBJETIVOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Proporcionar herramientas para la gestión y autogestión del tiempo de ocio</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Diferenciar entre uso y abuso</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Conocer los beneficios de las nuevas tecnologías en educación</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Entender los riesgos de internet</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Aprender a identificar y prevenir situaciones de ciberacoso</p>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
        <div class="col-12 col-lg-6">
          <div class="col-12 col-lg-12 separacion">
            <img src="assets/emocionEducacion.png" alt="image" height="200">
          </div>
          <h2 class="titulo naranja separacion">EMOCIÓN Y EDUCACIÓN</h2>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">A QUIÉN VA DIRIGIDO</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Familias</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Estudiantes</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">CONTENIDOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Identificación emocional</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Autoconocimiento y gestión emocional</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Empatía</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Asertividad</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">OBJETIVOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Conocer e identificar las propias emociones</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Mejorar la autogestión emocional</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Desarrollar la capacidad de ponerse en el lugar del otro</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Mejorar la comunicación de una forma asertiva</p>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="col-12 col-lg-12 separacion">
            <img src="assets/relacionesAfectivasSanas.png" alt="image" height="200">
          </div>
          <h2 class="titulo naranja separacion">RELACIONES AFECTIVAS SANAS</h2>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">A QUIÉN VA DIRIGIDO</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Adolescentes</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">CONTENIDOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Igualdad en las relaciones</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Relaciones sanas</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Asertividad y comunicación efectiva</p>
                  </li>
                </ul>
              </li>
              <li>
                <p style="margin-bottom: 0px;">OBJETIVOS</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Identificar los propios sentimientos en los distintos tipos de relaciones</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Aprender a gestionar los conflictos en las relaciones afectivas</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Fomentar la igualdad de trato</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Comprender e interiorizar conceptos como asertividad, límites y comunicación efectiva</p>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
        <div class="col-12 col-lg-6">
          <div class="col-12 col-lg-12 separacion">
            <img src="assets/queNecesitariaElCole.png" alt="image" height="200">
          </div>
          <h2 class="titulo naranja separacion">¿QUÉ NECESITARÍA EL COLE?</h2>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">TALLERES ADAPTADOS A LAS NECESIDADES DEL CENTRO</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Las necesidades de un colegio pueden variar debido a múltiples factores.</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Ofrecemos la posibilidad de desarrollar nuevos talleres adaptados a las necesidades de la comunidad educativa.</p>
                <ul>
                  <li>
                    <p style="margin-bottom: 0px;">Motivación</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Convivencia</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Género</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">Habilidades sociales</p>
                  </li>
                  <li>
                    <p style="margin-bottom: 0px;">...</p>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
      </div>
    </div>
  </div>